import { shallowEqual } from 'react-redux';

import { useSelector } from '../../../../selectors/useSelector';

import accessUtils from '../../../../utils/accessUtils';

import SFCostAndFeesTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeesTotalMonthlyPriceWithFeeAlert';
import SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert from '../../../Alerts/SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert';
import CostsAndFeesFormField from '../../CostsAndFees/components/CostsAndFeesFormField';

import { StyledReviewSection } from '../StyledComponents';

const CostsAndFeesContent = () => {
  const {
    appConfigCanAccessTotalMonthlyPriceWithFee,
    cookieEnabledServices,
    isOptInTotalMonthlyPriceWithFeeEligible,
    isTotalMonthlyPriceWithFeeEligible,
  } = useSelector(
    (state) => ({
      appConfigCanAccessTotalMonthlyPriceWithFee: state.app.appConfig.config.features.canAccessTotalMonthlyPriceWithFee,
      cookieEnabledServices: state.app.cookieEnabledServices,
      isOptInTotalMonthlyPriceWithFeeEligible:
        state.properties.currentProperty?.totalMonthlyPriceWithFee.isOptInEligible,
      isTotalMonthlyPriceWithFeeEligible: state.properties.currentProperty?.totalMonthlyPriceWithFeeNotice?.isEligible,
    }),
    shallowEqual,
  );

  const canAccessTotalMonthlyPriceWithFee = accessUtils.canAccessTotalMonthlyPriceWithFee({
    cookieEnabledServices,
    canAccessTotalMonthlyPriceWithFee: appConfigCanAccessTotalMonthlyPriceWithFee,
    isEligible: isTotalMonthlyPriceWithFeeEligible,
  });

  return (
    <div data-testid="CostsAndFeesContent" data-group-title="CostsAndFees">
      {canAccessTotalMonthlyPriceWithFee && <SFCostAndFeesTotalMonthlyPriceWithFeeAlert />}
      {isOptInTotalMonthlyPriceWithFeeEligible && <SFCostAndFeeOptInTotalMonthlyPriceWithFeeAlert />}

      <StyledReviewSection data-testid="CostsAndFeesReviewSection">
        <CostsAndFeesFormField displayedLocation="posting_path_review" />
      </StyledReviewSection>
    </div>
  );
};

export default CostsAndFeesContent;
